<template>
<div>
  <el-form style="margin-right: 40px" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="130px" class="demo-ruleForm">
    <el-form-item label="服务对象" prop="pid">
      <el-autocomplete v-if="paymentObj.isAdd && paymentObj.row === ''" style="width: 100%" class="inline-input" v-model="addEditForm.person_name"
                       :fetch-suggestions="querySearch" placeholder="请输入服务对象姓名" :trigger-on-focus="false" @select="handleSelect">
      </el-autocomplete>
      <span v-else>{{addEditForm.person_name}}</span>
    </el-form-item>
    <el-form-item v-if="paymentObj.isAdd" label="缴费金额" prop="change_amount">
      <el-input type="number" v-model="addEditForm.change_amount" placeholder="请输入"></el-input>
    </el-form-item>
    <el-form-item v-if="paymentObj.isAdd" label="缴费时间" prop="paid_date">
      <el-date-picker v-fixZoom style="width: 100%" v-model="addEditForm.paid_date" value-format="yyyy-MM-dd HH:mm:ss"
                      type="datetime" placeholder="选择日期时间" default-time="10:00:00"></el-date-picker>
    </el-form-item>
    <el-form-item label="缴费周期金额" prop="fee_amount">
      <el-input type="number" v-model="addEditForm.fee_amount" placeholder="请输入"></el-input>
    </el-form-item>
    <el-form-item label="缴费周期" prop="frequency">
      <el-select v-fixZoom v-model="addEditForm.frequency" style="width: 100%;" placeholder="请选择" @change="changefrequencys">
        <el-option v-for="item in frequencys" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="下次缴费时间" prop="due_date">
      <el-date-picker v-fixZoom style="width: 100%" v-model="addEditForm.due_date" value-format="yyyy-MM-dd HH:mm:ss"
                      type="datetime" placeholder="选择日期时间" default-time="10:00:00"></el-date-picker>
    </el-form-item>
    <el-form-item v-if="paymentObj.isAdd" label="缴费备注" prop="">
      <el-input v-model="addEditForm.remarks" placeholder="请输入"></el-input>
    </el-form-item>
  </el-form>
  <div style="margin-top: 30px;height: 60px">
    <el-row style="margin: 0 50px">
      <el-col :span="12">
        <div class="cancel-btn" @click="closeOpen()">
          <span>取消</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="send-btn" @click="submitPayment('addEditForm')">
          <span>确定</span>
        </div>
      </el-col>
    </el-row>
  </div>
</div>
</template>

<script>

import {searcholdperson} from '../../../api/serviceObject'
import {createpersoncarefeepayment, updatepersoncarefeereminder} from '../../../api/serviceMark'

export default {
  name: 'addEditPayment',
  model: {
    prop: 'openShow',
    event: 'change'
  },
  props: {
    paymentObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      frequencys: [
        {id: 30, name: '月', val: 86400000 * 30},
        {id: 90, name: '季度', val: 86400000 * 90},
        {id: 180, name: '半年', val: 86400000 * 180},
        {id: 360, name: '一年', val: 86400000 * 360}
      ],
      addEditForm: {
        id: '',
        pid: '',
        person_name: '',
        change_amount: '',
        paid_date: '',
        fee_amount: '',
        due_date: '',
        remarks: '',
        frequency: ''
      },
      addEditRules: {
        change_amount: [
          { required: true, message: '请输入缴费金额', trigger: 'blur' }
        ],
        pid: [
          { required: true, message: '请选择服务对象', trigger: 'change' }
        ],
        paid_date: [
          { required: true, message: '请选择缴费时间', trigger: 'change' }
        ],
        due_date: [
          { required: true, message: '请选择下次缴费时间', trigger: 'change' }
        ],
        fee_amount: [
          { required: true, message: '请输入缴费周期金额', trigger: 'change' }
        ],
        frequency: [
          { required: true, message: '请选择缴费周期', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    // eslint-disable-next-line no-extend-native
    Date.prototype.format = this.validate.format
    this.addEditForm.paid_date = new Date().format('yyyy-MM-dd hh:mm:ss')
    console.log(this.addEditForm.paid_date)
    if (this.paymentObj.isAdd) {
      if (this.paymentObj.row !== '') {
        this.addEditForm.pid = this.paymentObj.row.pid
        this.addEditForm.person_name = this.paymentObj.person_name
        this.addEditForm.change_amount = ''
        this.addEditForm.paid_date = ''
        this.addEditForm.fee_amount = this.paymentObj.row.fee_amount
        this.addEditForm.due_date = this.paymentObj.row.due_date
        this.addEditForm.remarks = this.paymentObj.row.remarks
        this.addEditForm.frequency = this.paymentObj.row.frequency
      }
    } else {
      this.addEditForm.id = this.paymentObj.row.id
      this.addEditForm.pid = this.paymentObj.row.pid
      this.addEditForm.person_name = this.paymentObj.person_name
      this.addEditForm.fee_amount = this.paymentObj.row.fee_amount
      this.addEditForm.due_date = this.paymentObj.row.due_date
      this.addEditForm.frequency = this.paymentObj.row.frequency
    }
  },
  methods: {
    // 姓名搜索服务对象
    querySearch (queryString, cb) {
      if (queryString.length < 1) {
        let arr = []
        cb(arr)
        return
      }
      let data = {
        lessname: queryString,
        page: 1,
        size: 9999
      }
      searcholdperson(data).then(res => {
        let re = []
        this.selectoldpersons = res.data.persons
        res.data.persons.forEach(item => {
          re.push({
            value: item.name + '(' + item.h_address + ')',
            row: item,
            id: item.id
          })
        })
        if (re.length === 0) {
          this.$message({ message: '暂无该服务对象。', type: 'warning' })
        }
        cb(re)
      }).catch(() => {
        let arr = []
        cb(arr)
      })
    },
    handleSelect (item) {
      console.log('item', item)
      this.addEditForm.pid = item.id
      console.log('22222', this.addEditForm.pid)
    },
    changefrequencys () {
      if (this.addEditForm.paid_date !== '') {
        let times = 0
        for (let i = 0; i < this.frequencys.length; i++) {
          if (this.addEditForm.frequency === this.frequencys[i].id) {
            times = this.frequencys[i].val
          }
        }
        let time = new Date(this.addEditForm.paid_date).getTime()
        this.addEditForm.due_date = new Date(times + time).format('yyyy-MM-dd hh:mm:ss')
      }
    },
    closeOpen () {
      this.$emit('change', false)
    },
    submitPayment (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.paymentObj.isAdd) {
            let data = {
              'pid': this.addEditForm.pid,
              'change_amount': parseFloat(this.addEditForm.change_amount),
              'paid_date': this.addEditForm.paid_date,
              'fee_amount': parseFloat(this.addEditForm.fee_amount),
              'due_date': this.addEditForm.due_date,
              'frequency': this.addEditForm.frequency,
              'remarks': this.addEditForm.remarks
            }
            createpersoncarefeepayment(data).then(res => {
              this.$notify({ title: '成功', message: '成功新增', type: 'success', duration: 2000 })
              this.$emit('change', false)
              this.$emit('getPayment')
            })
          } else {
            let data = {
              'id': this.addEditForm.id,
              'fee_amount': parseFloat(this.addEditForm.fee_amount),
              'due_date': this.addEditForm.due_date,
              'frequency': this.addEditForm.frequency
            }
            updatepersoncarefeereminder(data).then(res => {
              this.$notify({ title: '成功', message: '成功编辑', type: 'success', duration: 2000 })
              this.$emit('change', false)
              this.$emit('getPayment')
            })
          }
        } else {}
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/childComponents/addEditPayment.vue